import api from ".";

export const unitCrud = (data, method, callBack) => {
    let path = data?.id ? `/units/${data.id}/` : '/units/';

    const payload = { ...data };
    if (method !== 'get') {
        delete payload.id;
    }

    const config = method === 'get' && !data?.id
        ? { params: data }
        : payload;

    api[method](path, config)
        .then((response) => {
            callBack(response?.data);
        })
        .catch((error) => {
            callBack(error?.response);
        });
};
